import React, { FC, useCallback } from 'react';
import classNames from 'classnames';

import { TripState } from 'src/types/trips/Trips';
import TripStateIndicatorCalendar from 'src/common/components/TripStateIndicatorCalendar';
import EventShell from '../EventShell';
import Time from '../Time';
import { CalendarEvent } from '../../types';

const offSeasonTripState: TripState = {
  state: 'adHoc',
  role: 'adHoc',
  badge: 'Unavailable',
};

type OffSeasonEventProps = {
  event: CalendarEvent;
  openOffSeasonSummary: (boatHash: string) => void;
};

const OffSeasonEvent: FC<OffSeasonEventProps> = ({ event, openOffSeasonSummary }) => {
  const durationCount = event.total_days && event.total_days > 1
    ? `${event.day_number}/${event.total_days}`
    : undefined;

  const handleClick = useCallback(() => {
    openOffSeasonSummary(event.boat_ref);
  }, [event, openOffSeasonSummary]);

  return (
    <EventShell
      classNameModifier={classNames({ adHocSingleEvent: true })}
      eventType="adHoc"
      handleClick={handleClick}
      groupId={`off_season-${event.event_date}`}
      time={<Time event={event} isUnavailableEvent />}
      multiDayDuration={durationCount}
      title=""
      tripStateIndicator={<TripStateIndicatorCalendar tripState={offSeasonTripState} />}
    >
      {null}
    </EventShell>
  );
};

export default OffSeasonEvent;
